import { SdkError } from "@signaloid/cloud-compute-engine-client";

export function extractSdkErrorMessage(error: unknown): string {
	if (!(error instanceof SdkError)) {
		return "";
	}

	const body = error.details as { message?: unknown; Message?: unknown } | undefined;
	const message = body?.message ?? body?.Message;
	return typeof message === "string" ? message : "";
}
